import { environment } from '@environments/environment';

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';

import { AuthService } from '@views/misc/auth/auth.service';
import { StorageService } from '@views/misc/auth/storage.service';

import { FetchFilesRequest, FetchFilesResponse, UploadFileRequest, UploadFileResponse } from './files.types';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  private http = inject(HttpClient);
  private storageService = inject(StorageService);
  private authService = inject(AuthService);

  fetchList(payload: FetchFilesRequest): Observable<FetchFilesResponse> {
    const userId = this.storageService.getUserId();
    if (!userId) return EMPTY;
    const { pageIndex, pageSize } = payload;

    return this.http.get<FetchFilesResponse>(`${environment.endpointApiOne}/v1/files/users/${userId}`, {
      headers: this.authService.createAuthHeaders(),
      params: { pageIndex: `${pageIndex}`, pageSize: `${pageSize}` },
    });
  }

  uploadFile(payload: UploadFileRequest): Observable<UploadFileResponse> {
    const userId = this.storageService.getUserId();
    if (!userId) return EMPTY;
    const { contentType, loanFileTypeId, isPrivate, file, filename, bankAccountId } = payload;

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<UploadFileResponse>(`${environment.endpointApiOne}/v1/files/user/${userId}`, formData, {
      headers: this.authService.createAuthHeadersFile(filename),
      params: {
        contentType,
        loanFileTypeId: `${loanFileTypeId}`,
        isPrivate: `${isPrivate.toString()}`,
        ...(bankAccountId !== undefined ? { bankAccountId } : {}),
      },
    });
  }
}
